/* eslint-disable require-jsdoc */
/* eslint-disable no-magic-numbers */
import moment from 'moment-timezone';

export function momentNZ(date) {
    return moment(date).tz('Pacific/Auckland');
}
